module.exports = __webpack_public_path__ + "static/OneDot-Bold.723fccf1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDot-Bold.woff
// module id = 730
// module chunks = 114276838955818